import { router } from "@inertiajs/react";
import { useQueryClient } from "@tanstack/react-query";

interface UseTaskDismissOptions {
  redirectTo?: string;
  taskableType?: string;
}

export const useTaskDismiss = (taskId: number, options: UseTaskDismissOptions) => {
  const { redirectTo = "/dashboard", taskableType = "" } = options;

  const queryClient = useQueryClient();

  const handleDismiss = () => {
    router.post(
      `/tasks/${taskId}/dismiss`,
      {},
      {
        preserveScroll: true,

        onSuccess: () => {
          // We need to invalidate here because this happens within a Suspense boundary.
          // Without this invalidate, the task list would not be refetched in a timely manner,
          // causing subsequent dismiss requests to be potentially ignored.
          if (taskableType) {
            queryClient.invalidateQueries({ queryKey: ["task", taskableType] });
          } else {
            queryClient.invalidateQueries({ queryKey: ["tasks"] });
          }

          router.visit(redirectTo);
        },
      },
    );
  };

  return handleDismiss;
};

// Additional task-related hooks can be added here in the future
